import { SessionTranslation } from 'api/admin/models';
import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { actionsHandlers, stateFactories } from 'store/entities/utils';
import { EntityType } from 'store/entities/types';
import * as actions from './actions';

const stateFactory = stateFactories.createInitialEntitiesStateFactory<EntityType<SessionTranslation>>();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const adminSessionsTranslationsReducer = createReducer<State, Actions>(initialState, {
  [actions.getAdminSessionsTranslations.request.type]: actionsHandlers.handleGetManyRequest,
  [actions.getAdminSessionsTranslations.success.type]: actionsHandlers.handleGetManySuccess,
  [actions.getAdminSessionsTranslations.failure.type]: actionsHandlers.handleGetManyFailure,
  [actions.getAdminSessionsTranslations.reset.type]: actionsHandlers.handleGetManyReset,
  [actions.updateAdminSessionTranslation.request.type]: actionsHandlers.handleUpdateOneRequest,
  [actions.updateAdminSessionTranslation.success.type]: actionsHandlers.handleUpdateOneSuccess,
  [actions.updateAdminSessionTranslation.failure.type]: actionsHandlers.handleUpdateOneFailure,
  [actions.updateAdminSessionTranslation.reset.type]: actionsHandlers.handleUpdateOneReset,
});

export default adminSessionsTranslationsReducer;
